export default {
  statuses(state) {
    return state.status
  }
}
